"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultPagination = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const UrlService_1 = require("src/UrlService");
const HITS_PER_PAGE_ITEMS = [
    { label: '5', value: 5, default: false },
    { label: '10', value: 10, default: true },
    { label: '15', value: 15, default: false },
];
let isMounted = false;
const useSearchResultPagination = (selectedTabKey, totalResults) => {
    const { refine: refineHitsPerPage } = (0, react_instantsearch_1.useHitsPerPage)({
        items: HITS_PER_PAGE_ITEMS,
    });
    const [pageSize, setPageSize] = React.useState(() => Number(UrlService_1.UrlService.GetQueryValueFromUrl('pageSize')) || 10);
    let totalPages = React.useMemo(() => {
        return Math.ceil(totalResults / pageSize);
    }, [totalResults, pageSize, selectedTabKey]);
    const { nbPages, currentRefinement, refine } = (0, react_instantsearch_1.usePagination)({
        totalPages,
    });
    React.useEffect(() => {
        if (totalPages > 0 && nbPages > 0 && currentRefinement > nbPages) {
            refine(0);
        }
    }, [totalPages, nbPages, currentRefinement, totalResults, selectedTabKey]);
    React.useEffect(() => {
        if (!isMounted) {
            isMounted = true;
            return;
        }
        refine(0);
    }, [selectedTabKey, refine]);
    const refinePageSize = React.useCallback((size) => {
        setPageSize(size);
        refineHitsPerPage(size);
    }, [refineHitsPerPage]);
    return {
        currentPage: currentRefinement,
        totalPages: nbPages,
        pageSize,
        refinePage: refine,
        refinePageSize,
    };
};
exports.useSearchResultPagination = useSearchResultPagination;
